<template>
  <div class="swiperslide">
    <div class="box">
      <div v-if="swiperList.length >1">
        <swiper :options="swiperOption">
          <swiper-slide v-for="item in swiperList">
            <div class="slider">
              <img @click="toLink(item)" :src="item.appendurl?picAddr + item.appendurl.replace('/upload/', ''):''"/>
            </div>
            <!--<div class="w-inner"><span class="desc">{{item.appendcontent}}</span></div>-->
          </swiper-slide>
          <div class="swiper-pagination  pagination" slot="pagination" style="cursor: pointer;"></div>
        </swiper>
      </div>
      <div v-else-if="swiperList.length===1 && swiperList[0]" class="slider">
        <div class="slider">
          <img  @click="toLink(swiperList[0])" :src="swiperList[0].appendurl?picAddr + swiperList[0].appendurl.replace('/upload/', ''):''"/>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {swiper, swiperSlide} from 'vue-awesome-swiper'

  export default {
    props: ['swiperList'],
    data () {
      return {
        swiperOption: {
          pagination: '.swiper-pagination',
          paginationClickable: true,
          spaceBetween: 30,
          centeredSlides: true,
          autoplay: 5500,
          autoplayDisableOnInteraction: false
        }
      }
    },
    methods: {
      toLink (item) {
        if (item.appendlinkaddr) {
          window.location.href = item.appendlinkaddr
        }
      }
    },
    components: {swiper, swiperSlide},
    computed: mapState({
      picAddr: state => state.picAddr
    })
  }
</script>

<style lang="stylus">
  .swiperslide
    .swiper-wrapper
      width: 8000%;
      float: left;
    .swiper-slide
      float: left;
    .swiper-pagination-bullet
      background: #fff;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      margin-right: 10px;
    .swiper-pagination-bullet-active
      background: #fc5d3f;
    .box
      width: 100%
      overflow: hidden
      position: relative
      .slider
        background-position: center center;
        background-repeat: no-repeat;
        img
          width: 100%;
          height: 100%;
      .pagination
        position: absolute;
        bottom: 25px;
        left: 0px;
        display: flex;
        width: 100%;
        justify-content: center;
        z-index: 9999;
</style>



// WEBPACK FOOTER //
// SwiperList.vue?1b0dac9e